module.exports = __webpack_public_path__ + "img/home3.a23c29d6.jpg";